
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/new-car-finance/[make]",
      function () {
        return require("private-next-pages/new-car-finance/[make].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/new-car-finance/[make]"])
      });
    }
  